(function () {
  "use strict";

  var toastEl = document.getElementById("toast");
  function showToast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add("show");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      toastEl.classList.remove("show");
    }, 2200);
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error("add-to-cart-failed");
        return res.json();
      })
      .then(function (item) {
        showToast("Dodano: " + item.product_title);
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch(function () {
        showToast("Nie udało się dodać do koszyka");
      });
  });

  document.addEventListener("cart:updated", function () {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll(".cart-count").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  });

  var carouselRoot = document.getElementById("highlightCarousel");
  if (carouselRoot) {
    var track = carouselRoot.querySelector(".carousel-track");
    var prevBtn = carouselRoot.querySelector(".carousel-arrow.prev");
    var nextBtn = carouselRoot.querySelector(".carousel-arrow.next");
    var cards = Array.prototype.slice.call(track.children);

    if (cards.length) {
      track.classList.add("carousel-track-single");
      cards[0].classList.add("is-active");

      var dotsWrap = document.createElement("div");
      dotsWrap.className = "carousel-dots";
      dotsWrap.innerHTML = cards.map(function (_, i) {
        return '<button class="carousel-dot' + (i === 0 ? " is-active" : "") + '" aria-label="Slajd ' + (i + 1) + '"></button>';
      }).join("");
      carouselRoot.appendChild(dotsWrap);
      var dots = Array.prototype.slice.call(dotsWrap.children);

      var current = 0;
      var timer = null;

      function goTo(index) {
        current = (index + cards.length) % cards.length;
        cards.forEach(function (c, i) { c.classList.toggle("is-active", i === current); });
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === current); });
      }

      dots.forEach(function (d, i) {
        d.addEventListener("click", function () { goTo(i); resetAutoplay(); });
      });

      if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); resetAutoplay(); });

      function startAutoplay() {
        timer = setInterval(function () { goTo(current + 1); }, 4500);
      }
      function resetAutoplay() {
        clearInterval(timer);
        startAutoplay();
      }

      carouselRoot.addEventListener("mouseenter", function () { clearInterval(timer); });
      carouselRoot.addEventListener("mouseleave", startAutoplay);
      startAutoplay();
    }
  }

  var faqList = document.getElementById("faqList");
  if (faqList) {
    faqList.querySelectorAll(".faq-item").forEach(function (item) {
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a");
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        faqList.querySelectorAll(".faq-item.is-open").forEach(function (other) {
          other.classList.remove("is-open");
          other.querySelector(".faq-a").style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add("is-open");
          a.style.maxHeight = a.scrollHeight + "px";
        }
      });
    });
  }

  var siteHeader = document.querySelector("header.site");
  if (siteHeader) {
    var onScroll = function () {
      siteHeader.classList.toggle("is-scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }
})();
